import React from 'react';

import {
    Input,
    Select,
    Row,
    Col,
    Button,
} from 'antd';

import SearchInput from '../payment-advice/search-input';

const { Option } = Select;

class EntitySearch extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            entityType: '',
            entityId: ''
        }
    }

    render() {
        return (
            <Row display='flex' align='middle' gutter={8} style={{marginBottom: 10}}>
                <Col span={8}>
                    <div className='layout-row layout-align-start-center'>
                        <div style={{whiteSpace:'nowrap', marginRight: 8}}>Entity Type:</div>
                        <Select
                            placeholder="Select an Entity Type"
                            onChange={this.onEntityTypeChange}
                            allowClear
                            style={{width: '100%'}}
                        >
                            <Option value="user">User</Option>
                            <Option value="enterprise">Enterprise</Option>
                            <Option value="corpbilling">Corp Billing</Option>
                        </Select>
                    </div>
                   
                </Col>
                <Col span={8}>
                    <div className='layout-row layout-align-start-center'>
                        <div style={{whiteSpace:'nowrap', marginRight: 8}}>Entity Name:</div>
                        <SearchInput
                            style={{width: '100%'}}
                            placeholder="Select Entity Name"
                            entityType={this.state.entityType}
                            onChange={this.onEntityNameChange}
                        />
                    </div>
                </Col>
                <Col span={7}>
                    <div className='layout-row layout-align-start-center'>
                        <div style={{whiteSpace:'nowrap', marginRight: 8}}>Entity Id:</div>
                        <div>{this.state.entityId}</div>
                    </div>
                </Col>
                <Col span={1}>
                    <Button 
                        type="primary"
                        onClick={this.clearFields}>
                        Clear
                    </Button>
                </Col>
            </Row>

        )
    }

    clearFields = () => {
        this.setState({
            entityType: '',
            entityId: ''
        }, this.props.onEntityNameSelected({
            entityType: '',
            entityId: ''
        }))
    }

    onEntityTypeChange = (value) => {
        this.setState({
            entityType: value
        })
    }

    onEntityNameChange = (value) => {
        const { entityType } = this.state;

        this.setState({
            entityId: value
        })
        this.props.onEntityNameSelected({
            entityType,
            entityId: value
        })
    };

}

export default EntitySearch


// WEBPACK FOOTER //
// ./src/components/credit-overview/entity-search.js